/* AD-01 · DIRECTORY & READ-ONLY DETAIL
   ADM-01/02: plan, Locations, usage, integrations, email, incidents, risk —
   no raw customer data browsing. · Bible XVI */
import { Input } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD01Workspaces() {
  const d = useAdmin()
  return (
    <section data-frame="AD-01" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>Workspaces</h2>
        <div style={{ width: 260 }}>
          <Input placeholder={d.workspacesSearch} aria-label="Rechercher un workspace" readOnly />
        </div>
      </div>
      <div className="tablewrap">
        <table className="tbl">
          <thead>
            <tr><th>Workspace</th><th>Offre</th><th>Établ.</th><th>Usage</th><th>Risque</th></tr>
          </thead>
          <tbody>
            {d.workspaces.map(w => (
              <tr key={w.name}>
                <td><strong>{w.name}</strong></td>
                <td>{w.offer}</td>
                <td>{w.locations}</td>
                <td>{w.usage}</td>
                <td><Mark cell={w.risk} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="t-body">
        Détail = lecture seule (identité, entitlement, état des fonctions, alertes) — données
        support-safe uniquement. Toute écriture passe par une action typée et auditée.
      </p>
    </section>
  )
}
